require('./bootstrap');

window.Vue = require('vue');
window.Slick = require('slick-carousel/slick/slick');
window.MatchHeight = require('jquery-match-height/dist/jquery.matchHeight');
window.Custom = require('./custom');
window.SmoothScroll = require('./smoothScroll');
require('lightbox2');
require('bootstrap-select');
require('./jquery.vide');

Vue.component('registration-form', require('./components/RegistrationForm').default);
Vue.component('partners', require('./components/Partners').default);

import store from "./store";

const app = new Vue({
    el: '#app',
    store,
});
